<template>
  <ChartPlotly
    :data="data"
    :layout="computedLayout"
    :toImageButtonOptions="toImageButtonOptions"
    v-on="$listeners"
  ></ChartPlotly>
</template>

<script>
import deepmerge from "deepmerge";

const logo = require("@/assets/rex-logo.png");

const acelerexLogo = {
  source: `${window.location.protocol}//${window.location.host}${logo}`,
  xref: "paper",
  yref: "paper",
  x: 1,
  y: 0.05,
  sizex: 0.09,
  sizey: 0.09,
  xanchor: "right",
  yanchor: "bottom",
  opacity: 0.6,
  layer: "below",
};

export default {
  name: "ChartTimeseries",
  components: {
    ChartPlotly: () => import("@/components/charts/Plotly.vue"),
  },
  mixins: [],
  props: {
    data: {
      type: Array,
      required: true,
    },
    layout: {
      type: Object,
      required: false,
      default: () => {},
    },
    toImageButtonOptions: {
      type: Object,
      required: false,
      default: () => ({ format: "png" }),
    },
  },
  data() {
    return {};
  },
  computed: {
    computedLayout() {
      return deepmerge(
        {
          margin: { t: 40 },
          images: [acelerexLogo],
          xaxis: {
            type: "date",
          },
          height: 400,
          legend: { orientation: "h" },
          font: { size: "10" },
        },
        this.layout
      );
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
